/**
 * Thin gradient divider with a centered sparkle. Designed to sit between
 * stacked sections — it occupies only a few pixels of height so the sections
 * above and below still meet cleanly at the seam. Drop it as a sibling between
 * two <section> elements.
 */
export function SparkleDivider() {
  return (
    <div className="relative z-10 h-0 w-full" aria-hidden="true">
      <div
        className="absolute left-0 right-0 top-0 h-[2px] -translate-y-1/2 rounded-full shadow-[0_0_10px_rgba(236,72,153,0.35)]"
        style={{
          background:
            "linear-gradient(90deg, var(--color-primary), var(--color-pink), var(--color-violet), var(--color-electric))",
        }}
      />
      <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center text-lg leading-none text-primary drop-shadow-[0_0_10px_rgba(244,63,94,0.8)]">
        ✦
      </span>
    </div>
  );
}

